import type { ReactNode } from "react";

/** Ana menü kartlarının sol ikon kutusu. Renk `className` ile (text-mint vb.) verilir. */
export function ModeIcon({ className = "", children }: { className?: string; children: ReactNode }) {
  return (
    <span className={`mode-icon ${className}`} aria-hidden="true">
      {children}
    </span>
  );
}

function Svg({ children }: { children: ReactNode }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export function CalendarIcon() {
  return (
    <Svg>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
      <path d="M8.5 14.5h2M13.5 14.5h2" />
    </Svg>
  );
}

export function InfinityIcon() {
  return (
    <Svg>
      <path d="M12 12c-2-2.6-3.6-4-5.5-4a4 4 0 0 0 0 8c1.9 0 3.5-1.4 5.5-4Zm0 0c2 2.6 3.6 4 5.5 4a4 4 0 0 0 0-8c-1.9 0-3.5 1.4-5.5 4Z" />
    </Svg>
  );
}

export function FriendsIcon() {
  return (
    <Svg>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
      <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8" />
      <path d="M18.5 14a6.5 6.5 0 0 1 3 6" />
    </Svg>
  );
}

export function HistoryIcon() {
  return (
    <Svg>
      <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" />
      <path d="M3.5 4v4.5H8" />
      <path d="M12 7.5V12l3 2" />
    </Svg>
  );
}

export function StatsIcon() {
  return (
    <Svg>
      <path d="M3 20h18" />
      <path d="M6.5 16.5v-5M12 16.5V6M17.5 16.5v-8" />
    </Svg>
  );
}

export function TrophyIcon() {
  return (
    <Svg>
      <path d="M8 4h8v5a4 4 0 0 1-8 0V4Z" />
      <path d="M8 6H5.5a2.5 2.5 0 0 0 2.6 3.9M16 6h2.5a2.5 2.5 0 0 1-2.6 3.9" />
      <path d="M12 13v3.5M8.5 20h7M10 16.5h4" />
    </Svg>
  );
}
